export default class Module {
  constructor(handler) {
    this.handler = handler
  }

  /**
   * Initialize module
   * @param {Object} handler handler
   */
  init(handler = null) {
    this.handler = handler

    this.initMock(this._handler)

    return this
  }

  /**
   * Initialize mock handlers
   * @param {Object} handler http handler
   */
  initMock(handler) { }

  /**
   * Parse received data from backend
   * @param {Object} res received response
   * @param {Function} dataParser if we want to parse data, we can pass it in here
   * @return {Object}
   */
  parseResponse(res, dataParser) {
    const parsed = {
      message: res.message,
      code: res.code,
      data: dataParser ? dataParser(res.data) : res.data,
      meta: res.meta
    }

    return parsed
  }

  parseResponseError(err) {
    if (!err) return err

    if (err.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      const e = err.response.data
      return {
        message: e.data ? e.data.message ? e.data.message : '' : '',
        status: e.status,
        code: e.code,
        data: e.data,
      }
    } else if (err.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      return {
        message: 'ERR_INTERNET_DISCONNECTED',
        status: '',
        code: 0,
        data: err.request
      }
    } else {
      // Something happened in setting up the request that triggered an Error
      return {
        message: err.message,
        status: '',
        code: 0,
        data: {
          message: ''
        }
      }
    }
  }

  /**
   * Handler setter
   */
  set handler(handler) {
    this._handler = handler
  }

  /**
   * Handler getter
   */
  get handler() {
    return this._handler
  }
}
